import { getApiOrigin } from '@/config/env';

export type ValidateStaffCodeResult =
  | { ok: true; staffCode: string; staffName: string }
  | { ok: false; error: string };

export async function validateStaffCode(staffCode: string): Promise<ValidateStaffCodeResult> {
  const code = staffCode.trim();
  if (!code) {
    return { ok: false, error: 'Invalid staff code' };
  }

  const res = await fetch(`${getApiOrigin()}/api/v1/staff/validate/${encodeURIComponent(code)}`);
  const data = (await res.json()) as {
    ok?: boolean;
    staffCode?: string;
    staffName?: string;
    error?: string;
  };

  if (res.ok && data.ok && typeof data.staffCode === 'string') {
    return {
      ok: true,
      staffCode: data.staffCode,
      staffName: typeof data.staffName === 'string' ? data.staffName : '',
    };
  }

  return {
    ok: false,
    error: typeof data.error === 'string' ? data.error : 'Invalid staff code',
  };
}
